const DEVICE_CONNECTION_STATUS_TYPES = {
    DISCONNECTED: 'disconnected',
    DISCONNECTED_WITH_RECONNECT: 'disconnected_with_reconnect',
    CONNECTED: 'connected',
};

const deviceConnectionStatusTypes = {
    ...DEVICE_CONNECTION_STATUS_TYPES,
    isDisconnected: (status) => status === DEVICE_CONNECTION_STATUS_TYPES.DISCONNECTED,
    isDisconnectedWithReconnect: (status) => status === DEVICE_CONNECTION_STATUS_TYPES.DISCONNECTED_WITH_RECONNECT,
    isConnected: (status) => status === DEVICE_CONNECTION_STATUS_TYPES.CONNECTED,
};

export default deviceConnectionStatusTypes;
